import {Injectable} from "@angular/core";
import {Api3Service} from "../../../../common/services/api3.service";
import {Api} from "../../../../common/services/api.service";


@Injectable()
export class AdminPartnerService {

    public constructor(private apiService: Api3Service) {
    }

    public getPartners(query: any = {}): Promise<Api.IResponse> {
        return this.apiService.request(Api.EMethod.Get, "admin/partners", {}, query);
    }

}
